import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-tabla-generica',
  templateUrl: './tabla-generica.component.html',
  styleUrls: ['./tabla-generica.component.scss']
})
export class TablaGenericaComponent implements OnInit, OnChanges {

  @Input() datos;
  @Input() cols;
  @Input() showActions: boolean;
  @Input() showEdit: boolean;
  @Input() showPreview: boolean;
  @Input() showCheck: boolean;
  @Input() showPaginator: boolean;
  @Input() showRowsPerPage: number = 5;
  @Input() showSearch: boolean;
  @Input() showSort: boolean;
  @Input() showCaption: boolean;
  @Input() selectedItems;

  @Output() emitAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitSelection: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {

  }

  ngOnChanges() {}

  emitEvent(accion, rowData) {
    if (accion === 'check') {
        rowData.isChecked = !rowData.isChecked; // Toggle del estado del checkbox
    }
    this.emitAction.emit({ accion: accion, data: rowData, isSelected: rowData.isChecked });
  }


  emitirSelection() {
    if (this.selectedItems != null) {
      this.emitSelection.emit(this.selectedItems);
    }
  }

  deselectAllRows() {
    if (this.datos && this.datos.length > 0) {
        this.datos.forEach(data => {
            data.isChecked = false; // Deseleccionamos cada fila
        });
    }
    this.selectedItems = [];
    this.emitSelection.emit(this.selectedItems);
  }

  selectAllRows(users) {
    this.selectedItems = users;
    users.forEach(user => {
        user.isChecked = true; // Marcamos cada fila como seleccionada
    });
    this.emitSelection.emit(this.selectedItems);
  }

  rowSelection(rowData) {
    this.selectedItems = rowData;
    this.emitirSelection();
  }

  hayDatos() {
    if (this.datos.length > 0) {
      return true;
    }
    return false;
  }

  resolveData(data: object, path: string): any {
    return path.split('.').reduce((prev, curr) => {
        return prev ? prev[curr] : null
    }, data);
}
}
